import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable({ providedIn: 'root' })
export class isAuthenticatedGuard extends KeycloakAuthGuard {
  constructor(protected override router: Router, protected keycloak: KeycloakService) {
    super(router, keycloak);
  }

  public async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authenticated) {
      sessionStorage.setItem('shouldNotRedirect', 'false');
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url,
      });
    }

    return true;
  }
}
